import React from "react";
import { useLocation } from "react-router-dom";
import LeadParent from "components/Cards/LeadParent";
import ChatTable from "components/Cards/ChatTable";
// import TeamLeader from "components/Cards/TeamLeader";
import WorkerTable from "components/Cards/WorkerTable";
import MainTeamLead from "components/TeamLead/MainTeamLead";
import MainAgent from "components/Agent/MainAgent";
import TeamLeadDetails from "components/TeamLead/TeamLeadDetails";
import History from "components/History/History";

export default function HeaderStats() {
  const location = useLocation();

  const renderComponent = () => {
    switch (location.pathname) {
      case "/admin/worker":
        return <WorkerTable />;
      case "/admin/leads":
        return <LeadParent />;
      case "/admin/chats":
        return <ChatTable />;
      case "/team-lead":
        return <MainTeamLead />;
      case "/history":
        return <History />;
      case "/agent":
        return <MainAgent />;
      case "/details":
        return <TeamLeadDetails />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Header */}
      <div className="relative bg-gradient  md:pt-8 pt-8 h-[100vh] ">
        <div className="px-4 mx-auto w-full bg-gradient ">
          <div>
            {/* Card stats */}
            {renderComponent()}
          </div>
        </div>
      </div>
    </>
  );
}
